module.exports = __webpack_public_path__ + "static/media/quality-control.cab60f13.svg";